import { GenericLabel } from './GenericLabel';

export const EmptyValue = () => {
    return <GenericLabel name="-" />;
};
